import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const SearchIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g clipPath="url(#clip0)">
      <circle cx="6" cy="6" r="5" stroke="#2B3940" fill="none" strokeWidth="2" />
      <path d="M10 9.5L15 14.5" stroke="#2B3940" strokeWidth="2" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
SearchIcon.displayName = "SearchIcon";
SearchIcon.muiName = "SvgIcon";

export default pure(SearchIcon);
